import { render, staticRenderFns } from "./NormalSelect.vue?vue&type=template&id=8425a054&scoped=true&"
import script from "./NormalSelect.vue?vue&type=script&lang=js&"
export * from "./NormalSelect.vue?vue&type=script&lang=js&"
import style0 from "./NormalSelect.vue?vue&type=style&index=0&id=8425a054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8425a054",
  null
  
)

export default component.exports